module.exports = __webpack_public_path__ + "static/media/seventh_covered_bridge1.23258449.jpg";